import React, { Fragment } from "react";
import productData from "../../../components/data/exercice";
import PageTitle from "../../../layouts/PageTitle";
import SingleWork from "./SingleWork";
import JefitExercises from "../exerciceDataBase/JefitExercises";
import HeroWokoutComponent from "../Wokouts/Hero";
import ExerciseDatabase from "../exerciceDataBase/ExerciseDatabase";
import {fetchExerciseCategories} from "../../../../core/store/sport/categories_sport/thunk";

import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

const Workouts = ()=>{

   const dispatch = useDispatch();
   const { categories, status, error } = useSelector((state) => state.exerciseCategories);
 
   useEffect(() => {
     dispatch(fetchExerciseCategories())
     .then((response) => console.log("Réponse du dispatch :", response))
      .catch((error) => console.error("Erreur lors du dispatch :", error));;
   }, [dispatch]);
 
   if (status === "loading") return <p>Chargement...</p>;
   if (status === "failed") return <p>Erreur: {error}</p>;
   if (!Array.isArray(categories)) {
      return <p>Aucune catégorie disponible.</p>;
    }
  
 
    return (
        <Fragment>
          
      
        {/* <ExerciseDatabase/> */}
        <HeroWokoutComponent/>
           {/* <PageTitle activeMenu="Product Grid" motherMenu="Shop" /> */}
  
           <div className="row">
              {categories.map((category) => (
                 <SingleWork key={category.key} product={category} />
              ))}
           </div>
        </Fragment>
     );
}
export default Workouts


//cyciste https://www.youtube.com/watch?v=fSTHJ2otBpk&pp=ygUIQ3ljbGlzbWU%3D
//natation  https://www.youtube.com/watch?v=Vghj6ebWYJ8&pp=ygUITmF0YXRpb24%3D
//saut a corde  https://www.youtube.com/watch?v=PqWwILQRjJE&pp=ygUQU2F1dCDDoCBsYSBjb3JkZQ%3D%3D  

//       MUSCULATION
// deer couchervelop   https://www.youtube.com/watch?v=SngodvMU0JA&pp=ygUZc3BvcnQgRMOpdmVsb3Bww6kgY291Y2jDqQ%3D%3D
//squat n https://www.youtube.com/watch?v=J_Zm4XvE__s&pp=ygUMc3BvcnQgU3F1YXRzs
// soulever de terre https://www.youtube.com/watch?v=nkzKGyk8U0k&pp=ygUXc3BvcnQgU291bGV2w6kgZGUgdGVycmU%3D 
 //pompe  https://www.youtube.com/watch?v=HDFjA-uYRug&pp=ygUMc3BvcnQgUG9tcGVz


 //souplexe  https://www.youtube.com/watch?v=h5GI4PtxzxU&pp=ygUKc3BvcnQgUG9udA%3D%3D
 //posture de l'arbre  https://www.youtube.com/watch?v=t8KXifZclxM&pp=ygUYc3BvcnQgUG9zdHVyZSBkZSBsJ2FyYnJl
 // etirement https://www.youtube.com/watch?v=PC-KmNmLLVI&pp=ygUkc3BvcnQgw4l0aXJlbWVudCBkZXMgaXNjaGlvLWphbWJpZXJz